import { TNameTitle } from '@interfaces/common/common';

import { TVendorsValues } from '@enums/common';

export const checkFeatureAvailabilityForVendor = (
	vendors: TNameTitle<TVendorsValues, string>[] | undefined,
	restrictedVendors: TVendorsValues[],
): boolean => {
	if (!vendors) {
		return true;
	}

	return vendors
		.some((vendor) => !restrictedVendors
			.includes(vendor.name));
};
